












import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { StandardOption } from "../../system/selectors/mixins";
import { ProjectTeamSelectableMixin } from "./mixins";
import { ProjectTeam } from "../../../domain/projectTeam";
import { FixedLoading } from "../../system";

@Component({
  components: {
    OptionDropDownSelector,
    FixedLoading,
  },
})
export default class ProjectTeamDropDownSelector extends Mixins(ProjectTeamSelectableMixin) {
  @Prop({ default: true })
  isClearable: boolean;

  @Watch("isLoaded")
  onIsLoadedUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.loaded(this.options);
    }
  }

  @Emit()
  loaded(options: StandardOption<ProjectTeam>[]): void {}
}
